import { render, staticRenderFns } from "./testPreview.vue?vue&type=template&id=a3fb5074&scoped=true"
import script from "./testPreview.vue?vue&type=script&lang=js"
export * from "./testPreview.vue?vue&type=script&lang=js"
import style0 from "./testPreview.vue?vue&type=style&index=0&id=a3fb5074&prod&lang=scss&scoped=true"
import style1 from "./testPreview.vue?vue&type=style&index=1&id=a3fb5074&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3fb5074",
  null
  
)

export default component.exports